var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConnectColor = function SvgConnectColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D3D",
    d: "M40 80c22.091 0 40-17.909 40-40S62.091 0 40 0 0 17.909 0 40s17.909 40 40 40",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D3D",
    d: "M56.782 65.28c-4.75 3.332-10.498 5.488-16.69 5.488s-12.108-2.22-16.9-5.633a4.61 4.61 0 0 1-1.899-4.374l.472-3.439a29.6 29.6 0 0 0 18.227 6.295c6.676 0 12.853-2.187 17.943-6.074l.67 2.993a4.57 4.57 0 0 1-1.827 4.748z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#071C26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.2,
    d: "M47.181 10.285A24.8 24.8 0 0 0 38.94 9.25c-13.701.586-24.333 12.169-23.747 25.866a24.78 24.78 0 0 0 5.15 14.12c4.766 6.157 12.347 9.984 20.715 9.626 8.426-.361 15.69-4.876 19.894-11.49a24.66 24.66 0 0 0 3.85-14.379 24.8 24.8 0 0 0-1.23-6.732"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D3D",
    d: "m59.741 18.36 5.185-1.453c.369-.102.369-.623 0-.726l-5.177-1.476a.39.39 0 0 1-.263-.262l-1.453-5.185c-.102-.369-.623-.369-.726 0l-1.476 5.177a.39.39 0 0 1-.262.262l-5.185 1.454c-.369.102-.369.623 0 .726l5.177 1.476a.39.39 0 0 1 .263.262l1.453 5.185c.102.369.623.369.726 0l1.476-5.177a.39.39 0 0 1 .262-.263M47.59 26.969l3.549-.993a.259.259 0 0 0 0-.498l-3.545-1.012a.26.26 0 0 1-.18-.179l-.992-3.549a.259.259 0 0 0-.498 0l-1.012 3.545a.25.25 0 0 1-.179.179l-3.549.993a.259.259 0 0 0 0 .498l3.545 1.012a.26.26 0 0 1 .18.179l.992 3.548a.259.259 0 0 0 .498 0l1.012-3.545a.25.25 0 0 1 .179-.178M55.998 36.067l2.807-.787c.198-.057.198-.339 0-.396L56 34.086a.2.2 0 0 1-.14-.141l-.788-2.807c-.057-.198-.338-.198-.395 0l-.8 2.803a.2.2 0 0 1-.14.14l-2.807.788c-.198.057-.198.339 0 .396l2.803.798a.2.2 0 0 1 .141.141l.788 2.807c.057.198.338.198.395 0l.799-2.803a.2.2 0 0 1 .14-.14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#071C26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.2,
    d: "M23.458 36.333c-.692-6.615 2.408-12.75 7.543-16.25M36.558 17.588a18 18 0 0 1 2.45-.434"
  })));
};
export default SvgConnectColor;